export function isEmpty(variable) {
    if (variable  === undefined) return true;
    if (variable === null) return true;
    if (typeof variable === 'object' && Object.keys(variable).length === 0) return true;
    if (Array.isArray(variable) && variable.length === 0) return true;
    return false;
}